import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";



/* FOLDERS */
const getFoldersList = async ( parent_id = 0 ) => {
    let folders = [];

    let params = {
        'page' : 1,
        'per_page' : 0,
        'where' : {
            'parent_id' : parent_id
        },
        'order' : {
            'name' : 'ASC'
        }
    };

    let folders_list_response = await apiRequest(
                            "/media-library/folders/list?" + serialize(params),
                            {
                                'method' : "GET"
                            },
                            'ptp_client'
                        );
    if ( folders_list_response && typeof( folders_list_response.rows ) !== 'undefined' && folders_list_response.rows.length ) {
        folders = folders_list_response.rows;
    }

    return folders;
}


const getFolderById = async ( folder_id = 0 ) => {
    let folder = {};

    let params = {
        'page' : 1,
        'per_page' : 1,
        'where' : {
            'id' : folder_id
        },
        'order' : {
            'name' : 'ASC'
        }
    };

    let list_response = await apiRequest(
                            "/media-library/folders/list?" + serialize(params),
                            {
                                'method' : "GET"
                            },
                            'ptp_client'
                        );
    if ( list_response && typeof( list_response.rows ) !== 'undefined' && list_response.rows.length ) {
        folder = list_response.rows[0];
    }

    return folder;
}


const addFolder = async (params) => {
    let add_response = await apiRequest(
        "/media-library/folders/add",
        {
            'method'     : "POST",
            'headers'    : {
                'Content-Type' : 'application/json'
            },
            'body'     : JSON.stringify(params)
        },
        'ptp_client'
    );

    if ( add_response.id )
        return add_response.id;

    return false;
}


const updateFolder = async (params) => {
    let add_response = await apiRequest(
        "/media-library/folders/update",
        {
            'method'     : "PUT",
            'headers'    : {
                'Content-Type' : 'application/json'
            },
            'body'     : JSON.stringify(params)
        },
        'ptp_client'
    );

    if ( add_response.id )
        return add_response.id;

    return false;
}



const deleteFolder = async ( folder_id = 0 ) => {
    let delete_response = await apiRequest(
                            "/media-library/folders/delete/" + folder_id,
                            {
                                'method' : "DELETE"
                            },
                            'ptp_client'
                        );

    if ( delete_response.id )
        return delete_response.id;

    return false;
}




/* FILES */
const addFile = async ( params ) => {
    let add_file_response = await apiRequest(
                                        "/media-library/add",
                                        {
                                            'method' : "POST",
                                            'body' : params
                                        },
                                        'ptp_client'
                                    );
    if ( typeof(add_file_response.id) !== 'undefined' && add_file_response.id )
        return add_file_response.id;
    
    return false;
}


const getFilesList = async ( folder_id = 0 ) => {
    let files = [];

    let params = {
        'page' : 1,
        'per_page' : 0,
        'where' : {
            'folder_id' : folder_id
        },
        'order' : {
            'name' : 'ASC'
        }
    };

    let files_list_response = await apiRequest(
                            "/media-library/list?" + serialize(params),
                            {
                                'method' : "GET"
                            },
                            'ptp_client'
                        );
    if ( files_list_response && typeof( files_list_response.rows ) !== 'undefined' && files_list_response.rows.length ) {
        files = files_list_response.rows;
    }

    return files;
}


const deleteFile = async ( file_id = 0 ) => {
    let delete_response = await apiRequest(
                            "/media-library/delete/" + file_id,
                            {
                                'method' : "DELETE"
                            },
                            'ptp_client'
                        );

    if ( delete_response.id )
        return delete_response.id;

    return false;
}



const getImageUrl = ( image_path = '' ) => {
    if ( String(image_path).trim() === '' || image_path.indexOf('http') === 0 )
        return image_path;
    return getSluiceUrl('ptp_client') + "/media-library/files/" + image_path;
}


const MediaLibraryApi = {
    getFoldersList,
    getFolderById,
    addFolder,
    updateFolder,
    deleteFolder,

    addFile,
    getFilesList,
    deleteFile,

    getImageUrl
};
export default MediaLibraryApi;